// @flow

export type { ShopifyTheme } from './types';
export { ShopifyThemeProvider } from './provider';
export { fakeTheme } from './fake-theme';
